import formComponent from '@/util/proto/formComponent'
import { phoneValidator , idNumberValidator } from '@/util/validator'
import global from '@/util/mixin/global'
export default {
  mixins:[global],
  extends: formComponent ,
  components:{ },
  data() {
    return {
      formData: {
        repairUserName: {
          rules:[
            { required: true, message: '请输入姓名', trigger: 'blur,change' },
          ]
        },
        gender: {
          rules:[
            { type: 'number', required: false, message: '请选择性别', trigger: 'blur,change' },
          ]
        },
        phone: {
          rules:[
            { required: true, trigger: 'blur,change' ,validator: phoneValidator('请输入手机号', '请输入正确格式的手机号')},
          ]
        },
        idcard:{
          rules:[
            { required: true, message: '此项不能为空', trigger: 'blur,change' },
            { validator: idNumberValidator(), trigger: 'blur,change' },
          ]
        },
        repairSiteId:{
          rules:[
            { required: true, type:'number',message: '请选择所属站点', trigger: 'blur,change' },
          ]
        },
        orderModel:{
          rules:[
            { required: true, type:'number',message: '请选择接单模式', trigger: 'blur,change' },
          ]
        },
        entryTime: {
          rules:[
            { type: 'string', required: false, message: '请选择入职时间', trigger: 'blur,change' },
          ]
        },
        remark:null
        
      },
      id:null,
      loading:false,
      visible:false,
      api:['assEmpolyeeCreate','assEmpolyeeUpdate'],
    }
  },

  computed:{
    title(){
      return this.id ? '修改维修师' : '新增维修师'
    },
    passwordDecorator(){
      return [
        'password',
        {
          rules:[{ required: !this.id , message: '请输入密码名称', trigger: 'blur,change' }]
        }
      ]
    },
    branchs(){
      return new Promise((resolve , reject) => {
        return this.$request.assBranchsAll().then( resp => {
          resolve( resp.data.map(i => ({value:i.id , label:i.repairSiteName})))
        })
      })
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.assEmpolyee(this.id).then(resp => {
        this.$setFormData(resp.data)
        this.loading = false
      })
    },
    beforeSave(d){
      let params = { ...d }
      if(this.id){
        params.id = this.id
      }
      return params
    }
  },

  render(){
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          <sl-form-item label="姓名">
            <Input v-decorator={this.formData.repairUserName}></Input>
          </sl-form-item>
          <sl-form-item label="性别">
            <sl-select v-decorator={this.formData.gender} type="radio" dict="$gender" />
          </sl-form-item>
          <sl-form-item label="证件号码">
            <Input v-decorator={this.formData.idcard} maxlength={18}></Input>
          </sl-form-item>
          <sl-form-item label="联系电话">
            <Input v-decorator={this.formData.phone}></Input>
          </sl-form-item>
          <sl-form-item label="所属站点">
            <sl-select dict={this.branchs} v-decorator={this.formData.repairSiteId} />
          </sl-form-item>
          <sl-form-item label="入职时间">
            <DatePicker type="date" v-decorator={this.formData.entryTime}></DatePicker>
          </sl-form-item>
          <sl-form-item label="接单模式">
            <sl-select disabled={!this.isAdmin} v-decorator={this.formData.orderModel} type="radio" dict="employeeOrderModel" />
          </sl-form-item>
          
          <sl-form-item label="备注">
            <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-decorator={this.formData.remark}></Input>
          </sl-form-item>
        </sl-form>
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}

export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.assEmpolyee(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
           this.data = this.$utils.conv(resp.data,{'gender':'$gender' , 'entryTime':'datetime','orderModel':'employeeOrderModel'})
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data } = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="查看维修师" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="姓名">{data.repairUserName}</sl-detail-list-item>
          <sl-detail-list-item title="性别">{data.genderText}</sl-detail-list-item>
          <sl-detail-list-item title="证件号码">{data.idcard}</sl-detail-list-item>
          <sl-detail-list-item title="联系电话">{data.phone}</sl-detail-list-item>
          <sl-detail-list-item title="所属站点">{data.repairSiteName}</sl-detail-list-item>
          <sl-detail-list-item title="入职时间">{data.entryTimeText}</sl-detail-list-item>
          <sl-detail-list-item title="接单模式">{data.orderModelText}</sl-detail-list-item>
          <sl-detail-list-item title="今日接单数量">{data.todayOrder}</sl-detail-list-item>
          <sl-detail-list-item title="进行工单数">{data.repairOrder}</sl-detail-list-item>
          <sl-detail-list-item title="完成工单总数">{data.totalOrder}</sl-detail-list-item>
          
          <sl-detail-list-item title="备注">{data.remark}</sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}